export default {
  objective: '游戏目标',
  video_title: '不如亲眼看看',
  video: '动作示范视频',
  attention: '注意力请集中'
}
